module.exports = __webpack_public_path__ + "img/couples_18_V.39468f0c.webp";